<div class="visual-indicator-tab-wrapper">
  <div class="header">
    <span> Visual Indicators </span>
  </div>
  <div class="content-wrapper">
    <span class="info-text">
      Visual Indicators allow you to map colors to single select badging questions to be displayed in your Scoot room.
      This is limited to a maximum of 14 colors currently.
    </span>
    @if (singleSelectQuestions.length) {
      <mat-form-field class="welcome-custom-select-input w-full" appearance="outline">
        <mat-label>Visual Indicator</mat-label>
        <mat-select [(ngModel)]="selectedQuestion" placeholder="Select Question" (ngModelChange)="changeQuestion()">
          <mat-option>None</mat-option>
          @for (question of singleSelectQuestions; track question.title) {
            <mat-option [value]="question">{{ question.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (selectingColors) {
        @for (option of customOptionColor; track option.title; let i = $index) {
          <mat-expansion-panel class="custom-expansion-panel">
            <mat-expansion-panel-header>
              <div class="expansion-header-custom">
                <div class="visual-indicator" [ngStyle]="{ background: option.color }"></div>
                <span>
                  {{ option.title }}
                </span>
              </div>
            </mat-expansion-panel-header>
            <div class="visual-indicator-color-picker">
              @for (indicator of visualIndicatorColors; track indicator.colorNumber) {
                <div
                  class="color-item"
                  [ngStyle]="{ background: indicator.color }"
                  [ngClass]="{
                    active: option.colorNumber === indicator.colorNumber,
                    empty: !indicator.color,
                  }"
                  (click)="changeColor(i, indicator)"
                >
                  @if (!indicator.color) {
                    <div class="line"></div>
                  }
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      } @else {
        <button class="primary-button" [disabled]="!selectedQuestion" (click)="goToSelectColors()">Continue</button>
      }
    } @else {
      <div class="no-questions">
        <img src="/assets/images/illustrations/create_question_vi.svg" alt="Create questions placeholder image" />

        <div class="create-question-wrap">
          <p>Create a single select question and at least one answer choice in order to use visual indicators.</p>
          <app-home-button (click)="goToCreateQuestion()"> Create New Question </app-home-button>
        </div>
      </div>
    }
  </div>
</div>
